import src from "IMAGE";
export default { src, width: 6000, height: 4000, blurWidth: 0, blurHeight: 0};
